import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled as styling } from "@mui/material/styles";
import Image from "next/image";

export const Wrapper = styling(Grid)((props) => ({
  width: "100%",
  padding: "2%",

  [props.theme.breakpoints.down("tablet")]: {
    padding: "5%",
  },
}));

export const EmptyContainer = styling(Grid)((props) => ({}));

export const TypographyStyled = styling(Typography)({});

export const NextImageStyled = styling(Image)({});
